import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df23e1ab81b7a9/src/layout/home/homeContent.tsx");
